import Alpine from "alpinejs";
import AddressEdit from ":/components/Account/AddressEdit";
import AddressDelete from ":/components/Account/AddressDelete";
import ShippingAccountEdit from ":/components/Account/ShippingAccountEdit";
import ShippingAccountDelete from ":/components/Account/ShippingAccountDelete";
import CompanyAddressEdit from ":/components/Account/CompanyAddressEdit";

Alpine.data('AccountAddressEdit', AddressEdit)
Alpine.data('AccountAddressDelete', AddressDelete)
Alpine.data('AccountShippingAccountEdit', ShippingAccountEdit)
Alpine.data('AccountShippingAccountDelete', ShippingAccountDelete)
Alpine.data('AccountCompanyAddressEdit',CompanyAddressEdit)
